type SupportedUom = "kg" | "g" | "l" | "ml" | "Stk" | "Stück" | "Einheit(en)" | string;

const euroFormatter = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

const formatCurrency = (value: number): string => euroFormatter.format(value);

export const getUnitPriceLabel = (
    listPrice: number | null | undefined,
    contentQty: number | null | undefined,
    uom: SupportedUom | null | undefined
): string | null => {
    if (!listPrice || !contentQty || !uom) {
        return null;
    }

    let quantityInBaseUnit: number;
    let baseUom: string;

    switch (uom) {
        case "kg":
        case "l":
            quantityInBaseUnit = contentQty;
            baseUom = uom;
            break;

        case "g":
            quantityInBaseUnit = contentQty / 1000;
            baseUom = "kg";
            break;

        case "ml":
            quantityInBaseUnit = contentQty / 1000;
            baseUom = "l";
            break;

        case "Stk":
        case "Stück":
            quantityInBaseUnit = contentQty;
            baseUom = "Stk";
            break;

        case "Einheit(en)":
            if (contentQty < 1) {
                quantityInBaseUnit = contentQty;
                baseUom = "l";
            } else {
                quantityInBaseUnit = contentQty;
                baseUom = "Stk";
            }
            break;

        default:
            quantityInBaseUnit = contentQty;
            baseUom = uom;
            break;
    }

    if (quantityInBaseUnit <= 0) {
        return null;
    }

    const unitPrice = listPrice / quantityInBaseUnit;

    return `${formatCurrency(unitPrice)} / ${baseUom}`;
};